import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { lang } from './lang';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const langText = lang[locale] || lang['ph'];
    const getItems = () => [
        {
            title: langText['item_1'],
            titleColor: '#83868A',
        },
    ];
    return (
        <>
            <EcoTextTc items={getItems()} className={`${styles.comp} GtmModuleData-section`} data-section-id="FooterA" />
        </>
    );
}
